import { styled } from '@creditas-ui/system';
import {
  IconDocumentsNotesPages,
  IconCalculator,
  IconBookOpen4,
  IconBusinessChart14,
} from '@creditas-ui/icons';

const IconWrapperDefault = styled.span`
  width: 26px;
`;

const IconNavProposal = ({ active = false }: { active?: boolean }) => (
  <IconWrapperDefault>
    <IconDocumentsNotesPages
      color={active ? '#11bb77' : '#000'}
      strokeWidth={1}
    />
  </IconWrapperDefault>
);
const IconNavSimulation = ({ active = false }: { active?: boolean }) => (
  <IconWrapperDefault>
    <IconCalculator color={active ? '#11bb77' : '#000'} strokeWidth={1} />
  </IconWrapperDefault>
);
const IconNavMaterials = ({ active = false }: { active?: boolean }) => (
  <IconWrapperDefault>
    <IconBookOpen4 color={active ? '#11bb77' : '#000'} strokeWidth={1} />
  </IconWrapperDefault>
);
const IconBusiness = ({ active = false }: { active?: boolean }) => (
  <IconWrapperDefault>
    <IconBusinessChart14 color={active ? '#11bb77' : '#000'} strokeWidth={1} />
  </IconWrapperDefault>
);

export const items = [
  {
    id: 'proposals',
    active: window.location.pathname === '/',
    name: 'Propostas',
    goTo: () => window.location.assign('/'),
    link: '/',
    Icon: IconNavProposal,
  },
  {
    id: 'simulation',
    active: window.location.pathname === '/simulation',
    name: 'Simulação',
    goTo: () => window.location.assign('/simulation'),
    link: '/simulation',
    Icon: IconNavSimulation,
  },
  {
    id: 'support',
    active: window.location.pathname === '/support',
    name: 'Materiais de apoio',
    goTo: () => window.location.assign('/support'),
    link: '/support',
    Icon: IconNavMaterials,
  },
];

export const flagItems = [
  {
    id: 'dashboard',
    active: window.location.pathname === '/dashboard',
    name: 'Dashboard de performance',
    goTo: () => window.location.assign('/dashboard'),
    link: '/dashboard',
    Icon: IconBusiness,
  },
];
